import { classNames } from "lib/utils/helpers";
import { truncateString } from "lib/utils/helpers";
import { BundleItemType } from "lib/types/checkout";
import { OrderSummaryConfigType } from "lib/types/merchantConfigTypes";
import { getTextColorByBrightness } from "@shopflo/ui/utils";

export const BundleItem = ({
  image,
  variant_name,
  product_name,
  isCartItem,
  isUnservicable,
  customisations,
}: BundleItemType & {
  isCartItem: boolean;
  customisations?: OrderSummaryConfigType;
}) => {
  return (
    <div className="flex gap-3 py-1">
      <div className={classNames("w-10 h-10 object-contain rounded-lg overflow-hidden")}
        style={{
          borderColor: getTextColorByBrightness({ bgHexColor: customisations?.backgroundColor ?? '#FFFFFF', lightOpacity: 24 }),
        }}
      >
        <img
          src={image}
          alt={variant_name}
          className={classNames(
            `object-cover w-full h-full rounded-lg`,
            isUnservicable ? "grayscale" : "",
          )}
        />
      </div>
      <div className="flex flex-1">
        <p className="text-text-xs-medium line-clamp-2 text-wrap py-1"
          style={{
            color: customisations?.textColor ?? '#000000',
          }}
        >{truncateString(product_name, 38)}</p>
      </div>
    </div>
  );
};
